import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.object.seal";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { WOOSMAP_URL, WOOSMAP_GOOGLE_URL, WOOSMAP_KEY } from '~/const/3rd';
import CONFIG_STORE_LOCATOR from '~/const/3rd/woosmap/config-store-locator.json';
import { typeDefinition } from '~/helpers/editorial-helper';
import { fetchContent } from '~/services/editorial';
import Seo from '~/components/functional/Seo/EditorialSeo.vue';
import OpenGraph from '~/components/functional/OpenGraph/EditorialOpenGraph.vue';

var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

export default {
  components: {
    GlobalTitle: GlobalTitle,
    GlobalRichText: GlobalRichText,
    Seo: Seo,
    OpenGraph: OpenGraph
  },
  asyncData: function () {
    var _asyncData = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var error, store, _typeDefinition, type, _ref2, _ref2$results, _ref2$results$, id, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              error = _ref.error, store = _ref.store;
              _context.prev = 1;
              _typeDefinition = typeDefinition('store-locator'), type = _typeDefinition.type;
              _context.next = 5;
              return fetchContent(store, {
                type: type
              });

            case 5:
              _ref2 = _context.sent;
              _ref2$results = _slicedToArray(_ref2.results, 1);
              _ref2$results$ = _ref2$results[0];
              id = _ref2$results$.id;
              data = _ref2$results$.data;
              return _context.abrupt("return", {
                type: type,
                template: {
                  data: data
                },
                id: id,
                slices: []
              });

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](1);
              error({
                statusCode: 404,
                message: 'Not Found'
              });
              console.log(_context.t0);

            case 17:
              return _context.abrupt("return", false);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 13]]);
    }));

    function asyncData(_x) {
      return _asyncData.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {
      mapInitialized: false,
      tcVars: Object.seal({
        referer: this.$route.path,
        ga_link_state: '0',
        language: '',
        market: '',
        currentShop: '',
        currentShopId: '',
        newsletterEmail: '',
        env_3ds_activated: '0',
        page_url: this.$route.path,
        env_template: 'Home Page',
        env_work: 'Production',
        env_channel: 'site web',
        euro_rate_change: '1',
        env_language: '',
        env_country: '',
        user_id: '',
        user_email: '',
        user_category: '',
        compteur_meuble: 0,
        compteur_deco: 0
      })
    };
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    user: 'customer/user',
    userLogged: 'customer/isConnected'
  })),
  created: function created() {
    var _this = this;

    this.setTcVars('init woosmap');
    this.$root.$on('reset-tcvars', function () {
      _this.setTcVars('woosmap reset tcVars');
    });
  },
  mounted: function mounted() {
    this.$root.$on('woosmap-loaded', this.initMap);

    if ('WebApp' in window) {
      this.initMap();
    }
  },
  destroyed: function destroyed() {
    this.mapInitialized = false;
  },
  methods: {
    initMap: function initMap() {
      try {
        var webapp = new window.WebApp('store-locator', WOOSMAP_KEY);
        var isMobile = document.querySelector('body').clientWidth < 900;
        CONFIG_STORE_LOCATOR.internationalization.lang = this.locale.language;
        CONFIG_STORE_LOCATOR.maps.localities.language = this.locale.language;
        webapp.setConf(CONFIG_STORE_LOCATOR);
        webapp.render(isMobile);
        this.mapInitialized = true;
      } catch (err) {
        if (this.$sentry) {
          this.$sentry.captureException(err);
        }
      }
    },
    setTcVars: function setTcVars(message) {
      this.tcVars.env_country = this.locale.market;
      this.tcVars.env_language = this.locale.language;
      this.tcVars.market = this.locale.market;
      this.tcVars.language = this.locale.language;

      if (this.userLogged) {
        this.tcVars.user_email = this.user.user_email;
        this.tcVars.user_id = this.user.user_id;
        this.tcVars.user_category = this.$cookies.get('MDM[statut]') || this.user.user_type || '';
      }

      if (process.client && this.$cookies.get('debugmdm')) {
        console.log(message, _objectSpread({}, this.tcVars));
      }

      this.$root.$emit('updated-tcvars', this.tcVars);
    }
  },
  head: function head() {
    return {
      script: [{
        src: WOOSMAP_URL,
        body: true
      }, {
        src: WOOSMAP_GOOGLE_URL,
        body: true,
        async: true,
        defer: true
      }]
    };
  }
};